package one.healthium.paywall.di

import one.healthium.paywall.ui.scheduler.RemarketingScheduler
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

internal actual fun paywallPlatformModule() = module {
    singleOf(::RemarketingScheduler)
}